"use client"

import { Info } from "lucide-react"
// import { useNavigate } from "@tanstack/react-router"
// import { useDashboardBannerStore } from "../store/use-dashboard-banner-store"
import { useAuth } from "~/providers/auth.provider"
import { useEncounterIdStore } from "../../welcome/store/use-encounter-id-store"
import { useQuery } from "@tanstack/react-query"
import { medicalPlanQueryOptions } from "~/features/dashboard/api/queries/chat"
import { useNavigate } from "@tanstack/react-router"
// import { PatientMedicalPlan } from "~/features/dashboard/pages/patient-logs/api/types";

// interface DashboardBannerProps {
//   medicalPlan: any;
// }

export function DashboardBanner() {
  // const navigate = useNavigate()
  const {encounterId} = useEncounterIdStore()
  console.log("encounter_id", encounterId)
  // const { data: medicalPlan } = useQuery(medicalPlanQueryOptions(encounterId || ""));
  // console.log("DashboardBanner - medicalPlan:", medicalPlan);

  const { user } = useAuth();
  const { data: medicalPlan } = useQuery(medicalPlanQueryOptions(user?.medical_plan?.plan_id || ""));
  console.log("DashboardBanner - medicalPlan:", medicalPlan);
  const navigate = useNavigate()

  // console.log("DashboardBanner - currentTask:", currentTask);
  // console.log("DashboardBanner - medicalPlan:", medicalPlan);

  // Don't show banner if no current plan
  if (user?.has_plan && medicalPlan?.medical_plan.supplementary_questionnaire) return null

  const getBannerContent = () => {
    // If medical plan data is still loading or not available, don't show any banner yet related to it.
    if (!medicalPlan) {
      return null;
    }

    // Prioritize showing banner if consultation is missing
    // if (!medicalPlan.consultation) {
    //   return {
    //     title: "Choose Your Consultation Type",
    //     subtitle: "Select how you'd like to proceed with your consultation to continue your treatment.",
    //     buttonText: "Get started",
    //     onClick: () => navigate({ to: "/questionnaire", search: { step: 2 } }),
    //   }
    // }

    // // If consultation is present but medication is missing
    // if (!medicalPlan.medication) {
    //   return {
    //     title: "Complete Your Weight Loss Onboarding",
    //     subtitle: "You've started your journey — now let's finish setting things up so you can begin treatment.",
    //     buttonText: "Get started",
    //     onClick: () => navigate({ to: "/questionnaire", search: { step: 1 } }),
    //   }
    // }

    if (medicalPlan.medical_plan.supplementary_questionnaire === null) {
      return {
        title: "Complete Supplementary Questionnaire",
        subtitle: "Please complete this health questionnaire before your doctor reviews your case.",
        buttonText: "Get started",
        onClick: () => navigate({ to: "/dashboard/supplementary" }),
      }
    }

    return null
  }

  const bannerContent = getBannerContent()
  if (!bannerContent) return null

  return (
    <div className="mb-2 relative w-full bg-[#0404040D] flex items-center justify-center">
      <div className="absolute inset-0">
    {/* Flowing wave effect - multiple layers */}
    <div className="absolute inset-0 opacity-20">
      <div className="absolute w-full h-full bg-gradient-to-br from-white/30 via-transparent to-white/20 animate-pulse"></div>
    </div>
    
    {/* Main flowing wave */}
    <div className="absolute inset-0 opacity-25">
      <div 
        className="absolute w-[120%] h-[120%] -top-[10%] -left-[10%] bg-gradient-radial from-[#1FF9CD]/60 via-[#1FF9CD]/10 to-transparent animate-spin"
        // style={{ animationDuration: '20s' }}
      ></div>
    </div>
    
    {/* Secondary wave layer */}
    <div className="absolute inset-0 opacity-100">
      <div 
        className="absolute w-[140%] h-[140%] -top-[90%] -right-[10%] blur-xl"
        style={{ 
          transform: 'rotate(180deg)',
          background: 'radial-gradient(ellipse 60% 40% at 70% 30%, #115D28 0%, transparent 40%)'
        }}
      ></div>
    </div>

    <div className="absolute inset-0 opacity-100">
      <div 
        className="absolute w-[140%] h-[140%] -top-[100%] left-[50%] blur-xl"
        style={{ 
          transform: 'rotate(175deg)',
          background: 'radial-gradient(ellipse 60% 40% at 70% 30%, #11295D 0%, transparent 40%)'
        }}
      ></div>
    </div>
    
  </div>
      <div className="flex lg:flex-row flex-col lg:text-left text-center gap-2 items-center justify-between rounded-lg lg:w-[90%] px-4 py-3 shadow-sm">
        <div className="flex lg:flex-row flex-col items-center gap-3">
          <div className="lg:flex hidden h-6 w-6 items-center justify-center rounded-full bg-[#4272DD]">
            <Info className="h-4 w-4 text-white" />
          </div>
          <div className="flex-1">
            <h3 className="text-sm font-medium text-[#1F2937]">{bannerContent.title}</h3>
            <p className="text-sm text-[#6B7280]">{bannerContent.subtitle}</p>
          </div>
        </div>
        <button
          onClick={bannerContent.onClick}
          className="rounded-lg bg-[#4272DD] z-0 px-4 py-2 text-sm font-medium text-white transition-colors hover:bg-[#3461CC] focus:outline-none focus:ring-2 focus:ring-[#4272DD] focus:ring-offset-2"
        >
          {bannerContent.buttonText}
        </button>
      </div>
    </div>
  )
}
